import { PageLoader } from '@seek/libs-shared';
import { useRouteLoaderData } from 'react-router';
import { CompanyProfilesPage } from '../../../paths';
import { HomePage } from './HomePage';
import type { HomePageModel } from './homePageModel';

export function HomePageContainer(): JSX.Element {
  const model = useRouteLoaderData(CompanyProfilesPage.Home) as HomePageModel;

  return model ? <HomePage model={model} /> : <PageLoader />;
}
